import {Typography} from '@mui/material';
import Grid from '@mui/material/Grid';
import {bool} from 'prop-types';

import useBudget from '../../../../hooks/providers/useBudget';
import Switch from '../../../switch/Switch';

const AutoSaveButton = ({isSaving = false}) => {
  const {enableOrDisableAutoSave, autoSaveDisabled} = useBudget();

  return (
    <Grid container alignItems="center" spacing={0.5}>
      <Grid item>
        <Typography color="text.primary" fontWeight={300} fontSize={13} lineHeight={1}>
          Enregistrement automatique
        </Typography>
      </Grid>
      <Grid item position="relative">
        <Switch disabled={isSaving} data-testid="auto-save-switch" onChange={enableOrDisableAutoSave} checked={!autoSaveDisabled} />
      </Grid>
    </Grid>
  );
};

AutoSaveButton.propTypes = {
  isSaving: bool
};

export default AutoSaveButton;
